import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { AudioVideoConnectionMonitorModule } from 'src/app/features/audio-video-connection-monitor';
import { SharedModule } from 'src/app/features/shared';

import { NavigatorMediaDeviceWrapperService } from '../audio-video-connection-monitor/services/navigator-media-device-wrapper.service';
import { AudioVideoBlockedErrorModalComponent } from './components';
import { AudioVideoCheckInStepComponent, AudioVideoCheckPageComponent } from './containers';
import { AudioVideoCheckComponent } from './components/audio-video-component-check/audio-video-check.component';

import { AudioVideoCheckService } from './services/audio-video-check.service';
import { MicCheckService } from './services/mic-check.service';
import { SpeakerCheckService } from './services/speaker-check.service';

import { AudioVideoCheckEffects } from './store';
import { AudioVideoCheckReducers } from './store/reducers';
import { WizardModule } from '../wizard';

@NgModule({
  declarations: [AudioVideoBlockedErrorModalComponent, AudioVideoCheckInStepComponent],
  imports: [
    SharedModule,
    CommonModule,
    StoreModule.forFeature(
      'audioVideoCheck',
      AudioVideoCheckReducers.Reducers.audioVideoCheckReducer
    ),
    AudioVideoConnectionMonitorModule,
    ReactiveFormsModule,
    EffectsModule.forFeature([AudioVideoCheckEffects.AudioVideoCheckEffects]),
    AudioVideoCheckComponent,
    AudioVideoCheckPageComponent,
    WizardModule,
  ],
  providers: [
    AudioVideoCheckService,
    MicCheckService,
    NavigatorMediaDeviceWrapperService,
    SpeakerCheckService,
  ],
  exports: [AudioVideoCheckComponent, AudioVideoCheckInStepComponent, AudioVideoCheckPageComponent],
})
export class AvCheckModule {}
